// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dictionary-page {
  max-width: 800px;
  margin: 0 auto;
}

.dictionary-stats {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  padding: 16px;
  background: white;
  border-radius: 16px;
  box-shadow: var(--shadow);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--primary);
}

.stat-label {
  font-size: 12px;
  color: var(--text-light);
}

.dictionary-controls {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  margin-bottom: 12px;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: var(--primary);
}

.control-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.toggle-group {
  display: flex;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
}

.toggle-btn {
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-btn.active {
  background: var(--primary);
  color: white;
}

.dictionary-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dictionary-entry {
  background: white;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  border-left: 4px solid var(--primary);
}

.dictionary-entry.sentence {
  border-left-color: var(--accent);
}

.entry-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.entry-words {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.entry-primary {
  font-weight: 700;
  font-size: 16px;
  color: var(--text);
}

.entry-separator {
  color: var(--text-light);
}

.entry-secondary {
  color: var(--text-light);
  font-size: 15px;
}

.speak-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 8px;
  transition: background 0.2s;
}

.speak-btn:hover {
  background: #f0f0f0;
}

.entry-stats {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
}

.stat-badge {
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 11px;
}

.stat-text {
  color: var(--text-light);
}

.stat-item {
  font-size: 12px;
  color: var(--text-light);
  cursor: help;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.stat-item:hover {
  background-color: rgba(0, 0, 0, 0.08);
}

.stat-badge {
  cursor: help;
}

.type-badge {
  background: var(--accent);
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
}

.lesson-group {
  margin-bottom: 24px;
}

.lesson-group-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--primary);
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--primary);
}

.letter-group {
  margin-bottom: 16px;
}

.letter-separator {
  font-size: 24px;
  font-weight: 800;
  color: white;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  padding: 8px 16px;
  border-radius: 12px;
  margin-bottom: 8px;
  display: inline-block;
  min-width: 48px;
  text-align: center;
}

.no-items {
  text-align: center;
  padding: 60px 20px;
}

.no-items-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.no-items h2 {
  color: var(--text);
  margin-bottom: 8px;
}

.no-items p {
  color: var(--text-light);
}

@media (max-width: 600px) {
  .control-buttons {
    flex-direction: column;
  }

  .toggle-group {
    width: 100%;
  }

  .toggle-btn {
    flex: 1 1;
  }

  .entry-words {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .entry-separator {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Dictionary.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wEAAwE;EACxE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".dictionary-page {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.dictionary-stats {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 24px;\n  padding: 16px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: var(--shadow);\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.stat-label {\n  font-size: 12px;\n  color: var(--text-light);\n}\n\n.dictionary-controls {\n  margin-bottom: 20px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  margin-bottom: 12px;\n  transition: border-color 0.2s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.control-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.toggle-group {\n  display: flex;\n  background: #f0f0f0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.toggle-btn {\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.toggle-btn.active {\n  background: var(--primary);\n  color: white;\n}\n\n.dictionary-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dictionary-entry {\n  background: white;\n  border-radius: 12px;\n  padding: 12px 16px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  border-left: 4px solid var(--primary);\n}\n\n.dictionary-entry.sentence {\n  border-left-color: var(--accent);\n}\n\n.entry-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.entry-words {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.entry-primary {\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--text);\n}\n\n.entry-separator {\n  color: var(--text-light);\n}\n\n.entry-secondary {\n  color: var(--text-light);\n  font-size: 15px;\n}\n\n.speak-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.speak-btn:hover {\n  background: #f0f0f0;\n}\n\n.entry-stats {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 12px;\n}\n\n.stat-badge {\n  color: white;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 11px;\n}\n\n.stat-text {\n  color: var(--text-light);\n}\n\n.stat-item {\n  font-size: 12px;\n  color: var(--text-light);\n  cursor: help;\n  padding: 2px 6px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.stat-item:hover {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.stat-badge {\n  cursor: help;\n}\n\n.type-badge {\n  background: var(--accent);\n  color: white;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.lesson-group {\n  margin-bottom: 24px;\n}\n\n.lesson-group-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--primary);\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid var(--primary);\n}\n\n.letter-group {\n  margin-bottom: 16px;\n}\n\n.letter-separator {\n  font-size: 24px;\n  font-weight: 800;\n  color: white;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  padding: 8px 16px;\n  border-radius: 12px;\n  margin-bottom: 8px;\n  display: inline-block;\n  min-width: 48px;\n  text-align: center;\n}\n\n.no-items {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.no-items-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.no-items h2 {\n  color: var(--text);\n  margin-bottom: 8px;\n}\n\n.no-items p {\n  color: var(--text-light);\n}\n\n@media (max-width: 600px) {\n  .control-buttons {\n    flex-direction: column;\n  }\n\n  .toggle-group {\n    width: 100%;\n  }\n\n  .toggle-btn {\n    flex: 1;\n  }\n\n  .entry-words {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .entry-separator {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
